<template>
    <div class="page-layout blank contacts-manage">
        <div class="d-flex align-items-center justify-content-center h-100 mt-10" v-if="ajaxCallInProgress">
            <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
        </div>
        <div class="pl-3 pb-14" v-else>
            <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 d-flex justify-content-between align-items-center">
                    <div class="breadcrumbnew">
                        <span @click="$router.go(-1)">Conatct Dashboard</span>
                        <a> {{contact_details.first_name || "-"}}</a>
                    </div>
                    <div class="d-flex justify-content-between align-items-center">
                        <button @click="refresh"
                            class="btn btn-des-small ml-2 text-white" style="background:#00448b; height:30px">Refresh
                        </button>
                        <button @click="createSchedule()"
                            class="btn btn-des-small ml-2 text-white" :disabled="contact_details.status == 'archived'" style="background:#00448b; height:30px">+ Schedule Meeting
                        </button>
                        <button @click="viewContact($route.params.id)"
                            class="btn btn-des-small ml-2 mr-3 text-white" style="background:#00448b; height:30px"><i class="crmnew-user iconsize-13 iconsize pr-2" style="font-size: 14px; color: rgb(255, 255, 255);"></i>View Contact
                        </button>
                    </div>
                </div>
            </div>
            <div>
                <div class="row">
                    <div class="col-lg-3 col-md-12 col-sm-12 mt-2 pr-0">
                        <div class="col-lg-12 col-sm-12 col-md-12 pl-0 pr-0 mt-2" v-if="!expandprofile">
                            <fullscreen class="box-radius bg-white">
                                <div class="card-item bg-white text-auto" style="height: 140px;">
                                    <div class="d-flex justify-content-between">
                                        <div class="fw-600 fs-14 text-truncate" :title="contact_details.first_name" style="width: 60%;">{{contact_details.first_name || "-"}}</div>
                                        <div>
                                            <div class="social-media-edit" v-for="(social, index) in contact_social_media" :key="index" style="display: inline-block !important;">
                                                <a :href="social.media_url" v-if="index <= 2" target="_blanck" style="text-decoration: none;">
                                                    <img v-if="social.media_type == 'Facebook'" src="/static/images/facebooks.svg" target="_blank" style="margin-right: 5px; width: 20px; padding-bottom: 2px !important;">
                                                    <img v-if="social.media_type == 'Twitter'" src="/static/images/twitters.svg"  target="_blank" style="margin-right: 5px; width: 20px; padding-bottom: 2px !important;">
                                                    <img v-if="social.media_type == 'Linkedin'" src="/static/images/linked.svg"  target="_blank"  style="margin-right: 5px; width: 20px; padding-bottom: 2px !important;">
                                                    <img v-if="social.media_type == 'Instagram'" src="/static/images/instgrams.svg"  target="_blank"  style="margin-right: 5px; width: 20px; padding-bottom: 2px !important;">
                                                    <img v-if="social.media_type == 'Reddit'" src="/static/images/Redditblue.svg"  target="_blank"  style="margin-right: 5px; width: 20px; padding-bottom: 2px !important;">
                                                </a>
                                            </div>
                                        </div>
                                        <div>
                                            <!-- <button class="pointer btn-icon" @click="editLead(lead_details)">
                                                <img src="/static/images/images-new-theme/icons/edit.svg" height="15px;">
                                            </button> -->
                                            <span class="circle-button ml-1 pointer" @click="expandProfile">
                                                <i class="icon-chevron-down text-white org-icon-rotate-transition org-icon-down"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <hr style="border-top: 2px solid rgba(0,0,0,0.1) !important;">
                                    <div v-if="!expandprofile" class="fw-500 text-center d-flex justify-content-between aline-items-center mt-5" style="height:28px">
                                        <span
                                            class="text-left col-md-4 col-sm-4 col-lg-3 div-spacing" style="font-size: 12px;">Phone</span>
                                        
                                        <span
                                            class="text-left col-md-8 col-sm-8 col-lg-9 div-spacing text-truncate" :title="phone_number.phone_number" style="font-size: 12px;">{{phone_number.phone_number || "-"}}</span>
                                    </div>
                                    <div class="fw-500 text-center d-flex justify-content-between aline-items-center mt-1">
                                        <span
                                            class="text-left col-md-4 col-sm-4 col-lg-3 div-spacing" style="font-size: 12px;">Email ID</span>
                                        
                                        <span
                                            class="text-left col-md-8 col-sm-8 col-lg-9 div-spacing text-truncate" :title="contact_details.primary_email" style="font-size: 12px;">{{contact_details.primary_email || "-"}}</span>
                                    </div>
                                </div>
                            </fullscreen>
                        </div>
                        <div class="col-lg-12 col-sm-12 col-md-12 pl-0 pr-0 mt-2" v-if="expandprofile">
                            <fullscreen class="box-radius bg-white">
                                <div class="card-item bg-white text-auto" style="position: absolute;z-index: 999;width: 100%;box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.7);">
                                    <div class="d-flex justify-content-between aling-items-center">
                                        <div class="fw-600 pr-5 fs-14 text-truncate" :title="contact_details.first_name">{{contact_details.first_name}}</div>
                                        <!-- <div>
                                            <button class="pointer btn-icon" @click="editLead(lead_details)">
                                                <img src="/static/images/images-new-theme/icons/edit.svg" height="15px;">
                                            </button>
                                        </div> -->
                                    </div>
                                    <hr style="border-top: 2px solid rgba(0,0,0,0.1) !important;">
                                    <div style="height:100%;">
                                        <div class="fw-500 text-center d-flex justify-content-between aline-items-center mt-2">
                                            <span
                                                class="text-left col-md-5 col-sm-5 col-lg-5 div-spacing" style="font-size: 12px;">Company Name</span>
                                            
                                            <span
                                                class="text-left col-md-7 col-sm-7 col-lg-7 div-spacing text-truncate" :title="contact_details.company_name" style="font-size: 12px;">{{contact_details.company_name || "-"}}</span>
                                        </div>
                                        <div class="fw-500 text-center d-flex justify-content-between aline-items-center mt-2">
                                            <span
                                                class="text-left col-md-5 col-sm-5 col-lg-5 div-spacing" style="font-size: 12px;">Job Title</span>
                                            
                                            <span
                                                class="text-left col-md-7 col-sm-7 col-lg-7 div-spacing text-truncate" :title="contact_details.job_title" style="font-size: 12px;">{{contact_details.job_title || "-"}}</span>
                                        </div>
                                        <div class="fw-500 text-center d-flex justify-content-between aline-items-center mt-2">
                                            <span
                                                class="text-left col-md-5 col-sm-5 col-lg-5 div-spacing" style="font-size: 12px;">Phone</span>
                                            
                                            <span
                                                class="text-left col-md-7 col-sm-7 col-lg-7 div-spacing text-truncate" :title="phone_number.phone_number" style="font-size: 12px;">{{phone_number.phone_number || "-"}}</span>
                                        </div>
                                        <div class="fw-500 text-center d-flex justify-content-between aline-items-center mt-2">
                                            <span
                                                class="text-left col-md-5 col-sm-5 col-lg-5 div-spacing" style="font-size: 12px;">Email ID</span>
                                            
                                            <span
                                                class="text-left col-md-7 col-sm-7 col-lg-7 div-spacing text-truncate" :title="contact_details.primary_email" style="font-size: 12px;">{{contact_details.primary_email || "-"}}</span>
                                        </div>
                                        <div class="fw-500 text-center d-flex justify-content-between aline-items-center mt-2">
                                            <span
                                                class="text-left col-md-5 col-sm-5 col-lg-5 div-spacing" style="font-size: 12px;">Territory</span>
                                            
                                            <span
                                                class="text-left col-md-7 col-sm-7 col-lg-7 div-spacing text-truncate text-capitalize" style="font-size: 12px;">{{contact_details.territory || "-"}}</span>
                                        </div>
                                        <div class="fw-500 text-center d-flex justify-content-between aline-items-center mt-2">
                                            <span
                                                class="text-left col-md-5 col-sm-5 col-lg-5 div-spacing" style="font-size: 12px;">Industry Type</span>
                                            
                                            <span
                                                class="text-left col-md-7 col-sm-7 col-lg-7 div-spacing text-truncate":title="contact_details.industry_type"  style="font-size: 12px;">{{contact_details.industry_type || "-"}}</span>
                                        </div>
                                        <div class="fw-500 text-center d-flex justify-content-between aline-items-center mt-2">
                                            <span
                                                class="text-left col-md-5 col-sm-5 col-lg-5 div-spacing" style="font-size: 12px;">Introduced</span>
                                            
                                            <span
                                                class="text-left col-md-7 col-sm-7 col-lg-7 div-spacing text-truncate" style="font-size: 12px;">{{convertDate(contact_details.last_modified_time) || "-"}}</span>
                                        </div>
                                        <div v-if="contact_social_media.length > 0" class="fw-500 text-center d-flex justify-content-between aline-items-center mt-2">
                                            <span class="text-left col-md-12 col-sm-12 col-lg-12 div-spacing" style="font-size: 12px;">Social Media</span>
                                        </div>
                                        <div class="row d-flex pt-2">
                                            <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10">
                                                <div class="social-media-edit" v-for="(social, index) in contact_social_media" :key="index" style="display: inline-block !important;text-align: left !important;">
                                                    <a :href="social.media_url" target="_blanck" style="text-decoration: none;">
                                                        <img v-if="social.media_type == 'Facebook'" src="/static/images/facebooks.svg" target="_blank" style="margin-right: 5px; width: 20px; padding-bottom: 2px !important;">
                                                        <img v-if="social.media_type == 'Twitter'" src="/stati/images/twitters.svg"  target="_blank" style="margin-right: 5px; width: 20px; padding-bottom: 2px !important;">
                                                        <img v-if="social.media_type == 'twitter'" src="/static/images/twitters.svg"  target="_blank" style="margin-right: 5px; width: 20px; padding-bottom: 2px !important;">
                                                        <img v-if="social.media_type == 'Linkedin'" src="/static/images/linked.svg"  target="_blank"  style="margin-right: 5px; width: 20px; padding-bottom: 2px !important;">
                                                        <img v-if="social.media_type == 'Instagram'" src="/static/images/instgrams.svg"  target="_blank"  style="margin-right: 5px; width: 20px; padding-bottom: 2px !important;">
                                                        <img v-if="social.media_type == 'Reddit'" src="/static/images/Redditblue.svg"  target="_blank"  style="margin-right: 5px; width: 20px; padding-bottom: 2px !important;">
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2" style="text-align: right !important;display: inline-block !important;">
                                                <span class="circle-button ml-1 pointer" @click="expandProfile">
                                                    <i class="icon-chevron-up text-white org-icon-rotate-transition org-icon-down"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </fullscreen>
                        </div>
                        <div class="col-lg-12 col-sm-12 col-md-12 pl-0 pr-0 mt-2">
                            <fullscreen class="box-radius bg-white pb-5">
                                <div class="card-item bg-white text-auto pb-0" :class="{'height': expandprofile, 'height-one': !expandprofile}">
                                    <div class="d-flex justify-content-between aline-items-center">
                                        <div class="fw-600 pr-5 fs-14">Recent Activity</div>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-center" v-if="contact_interaction" style="height: 344px;">
                                        <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                                    </div>
                                    <div  v-if="interactions.length == 0 && !contact_interaction" style="height:344px;">
                                        <h6 class="contentCenter pt-20 text-center h-100 fw-600 w-100">
                                            <img src="/static/images/images-new-theme/icons/activity_no_card_selected.png" alt="" width="150px" height="150px">
                                            <h5 class="fw-500 text-capitalize fs-14 mt-4" style="color: #707070 !important;">No Activities!</h5>
                                        </h6>
                                    </div>
                                    <div v-if="interactions.length > 0 && !contact_interaction" class="row pr-3 pt-2 pb-2 pl-3" :class="{'recent-height': expandprofile, 'recent-activity': !expandprofile}" style="overflow-y: scroll !important;overflow-x: hidden !important;">
                                        <div>
                                            <div class="row pl-5">
                                                <ul class="timeline mt-3">
                                                    <li class="event justify-content-between align-items-center" v-for="(interaction,index) in interactions" :key="index">
                                                        <div class="mb-2 lead-status pt-2 pl-4 pointer">
                                                            <div class="mt-1">
                                                                <div class="fw-600 d-flex justify-content-between align-items-center fs-14 text-black mb-1 text-capitalize">
                                                                    <span class="text-truncate name-mx-width">
                                                                    </span>
                                                                </div>
                                                                <div style="margin-top: -15px !important;" class="text-truncate">
                                                                    <span class="fw-500" style="font-size: 12px;color: #000">{{interaction.action_type == 'remove' ? `${interaction.action_type}d` : interaction.action_type == 'create' ? 'Added' : `${interaction.action_type}ed`}}
                                                                        {{interaction.name == 'call_report' ? 'Call Report' : interaction.name}}
                                                                    </span>
                                                                </div>
                                                                <div style="margin-top: -5px !important;">
                                                                    <span class="fw-500" style="font-size: 10px;color: #707070">{{interaction.created_date}} |
                                                                        {{interaction.created_time_format}}</span>
                                                                </div>
                                                                <div class="fw-500"
                                                                    style="color: #707070;"></div>
                                                            </div>
                                                            <div class="lead-time mt-1"></div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div> 
                                </div>
                            </fullscreen>
                        </div>
                    </div>
                    <div class="col-lg-6 col-sm-12 col-md-12 pl-4 pr-0 mt-4">
                        <fullscreen class="box-radius bg-white" style="height:552px">
                            <div class="card-item bg-white text-auto">
                                <div class="d-flex justify-content-between aline-items-center">
                                    <div class="fw-600 pr-5 fs-14">Deal Associated</div>
                                    <div>
                                        <button @click="RedirectToCreateDeals(contact_details)"
                                            class="btn btn-des-small ml-2 text-white" :disabled="!userPermissions.deals.permitted_actions.create ||contact_details.status == 'archived'" style="background:#008a63; height:30px">+ Deals
                                        </button>
                                    </div>
                                </div>
                                 <div class="d-flex align-items-center justify-content-center h-100" v-if="contact_deals">
                                    <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                                </div>
                                <div  v-if="deal_details.length == 0 && !contact_deals" style="height:344px;">
                                    <h6 class="contentCenter pt-20 text-center h-100 fw-600 w-100">
                                        <img src="/static/images/contact-list.png" alt="" width="200px">
                                        <h5 class="fw-500 text-capitalize fs-14 mt-4" style="color: #707070 !important;">No Deals!</h5>
                                    </h6>
                                </div>
                                <div v-if="deal_details.length > 0 && !contact_deals" class="pl-3 pr-2" style="height:486px;overflow-y: auto !important;overflow-x: hidden !important;">
                                    <div class="row pr-0">
                                        <div class="col-lg-4 col-sm-12 col-md-6 pb-3 pl-2 pr-2 mt-2" v-for="(dealreport,dealreport_index) in deal_details" :key="dealreport_index">
                                            <div class="widget widget2 product-cards bg-white text-auto">
                                                <div class="d-flex justify-content-between aline-items-center">
                                                    <div style="padding-top:2px" class="text-truncate" :title="dealreport.name"><span class="product-header" style="color: #00448b;">{{dealreport.name || "-"}}</span></div>
                                                    <div>
                                                        <el-dropdown trigger="click" class="text-right" >
                                                            <i class="icon icon-circle fs-16"  :class="{'text-dark-red': dealreport.priority == 'high', 'text-medium-status': dealreport.priority == 'medium', 'text-low-status': dealreport.priority == 'low'}"></i>
                                                            <el-dropdown-menu slot="dropdown" class="priority-cursor">
                                                                <el-dropdown-item disabled>
                                                                    <span class="text-dark-red">High</span>
                                                                </el-dropdown-item>
                                                                <el-dropdown-item disabled>
                                                                    <span class="text-medium-status">Medium</span>
                                                                </el-dropdown-item>
                                                                <el-dropdown-item disabled>
                                                                    <span class="text-low-status">Low</span>
                                                                </el-dropdown-item>
                                                            </el-dropdown-menu>
                                                        </el-dropdown>
                                                    </div>
                                                </div>
                                                <div class="fw-500 text-center d-flex justify-content-between aline-items-center mt-1">
                                                    <span
                                                        class="text-left col-md-6 col-sm-6 col-lg-6 div-spacing" style="font-size: 10px;">Customer Name </span>
                                                    <span class="mx-1" style="margin-top: -2px !important;">:</span>
                                                    <span
                                                        class="text-left col-md-6 col-sm-6 col-lg-6 div-spacing text-truncate" :title="dealreport.customer_name" style="font-size: 10px;padding-right: 10px !important;">{{dealreport.customer_name || "-"}}</span>
                                                </div>
                                                <div class="fw-500 text-center d-flex justify-content-between aline-items-center">
                                                    <span
                                                        class="text-left col-md-6 col-sm-6 col-lg-6 div-spacing" style="font-size: 10px;">Contact Name</span>
                                                    <span class="mx-1" style="margin-top: -2px !important;">:</span>
                                                    <span
                                                        class="text-left col-md-6 col-sm-6 col-lg-6 div-spacing text-truncate" :title="dealreport.contact_name" style="font-size: 10px;padding-right: 10px !important;">{{dealreport.contact_name || "-"}}</span>
                                                </div>
                                                <div class="fw-500 text-center d-flex justify-content-between aline-items-center">
                                                    <span
                                                        class="text-left col-md-6 col-sm-6 col-lg-6 div-spacing" style="font-size: 10px;">Amount({{currency}})</span>
                                                    <span class="mx-1" style="margin-top: -2px !important;">:</span>
                                                    <span
                                                        class="text-left col-md-6 col-sm-6 col-lg-6 div-spacing text-truncate" :title="dealreport.total_transaction_value" style="font-size: 10px;padding-right: 10px !important;">{{dealreport.total_transaction_value || "-"}}</span>
                                                </div>
                                                <div class="fw-500 text-center d-flex justify-content-between aline-items-center">
                                                    <span
                                                        class="text-left col-md-6 col-sm-6 col-lg-6 div-spacing" style="font-size: 10px;">Expected Date</span>
                                                    <span class="mx-1" style="margin-top: -2px !important;">:</span>
                                                    <span
                                                        class="text-left col-md-6 col-sm-6 col-lg-6 div-spacing" style="font-size: 10px;padding-right: 10px !important;">{{convertDateFormate(dealreport.expected_close_date)}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </fullscreen>
                    </div>
                    <div class="col-lg-3 col-md-12 col-sm-12 mt-4">
                        <div class="col-lg-12 col-sm-12 col-md-12 pl-0 pr-3">
                            <fullscreen class="box-radius bg-white leadFullscreen"  style="height:552px !important;overflow-y: auto;">
                                <div class="card-item bg-white text-auto">
                                    <div class="d-flex justify-content-between aline-items-center">
                                        <div class="fw-600 pr-5 fs-14">Meetings</div>
                                        <div><button class="btn-blue fw-600 px-2 pointer" @click="goToViewDetails">View All</button></div>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-center pt-25" v-if="load_meeting">
                                        <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                                    </div>
                                    <h6 v-if="schedule_meetings.length == 0 && !load_meeting" class="contentCenter mt-30 text-center h-100 fw-600 w-100">
                                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/schedule_meeting.svg" alt="" width="150px" height="150px">
                                        <h5 class="fw-500 text-capitalize fs-14 mt-4" style="color: #707070 !important;">No Upcoming Meetings!</h5>
                                    </h6>
                                    <div v-if="schedule_meetings.length > 0 && !load_meeting" class="upcoming-card row" v-for="(meeting, meeting_index) in schedule_meetings" :key="meeting_index">
                                        <div class="col-lg-4 col-md-4 col-sm-4" style="border-right: 1px solid #cdd2da;">
                                            <div v-if="meeting_index < 9" class="d-flex flex-column calendar-data justify-content-center" style="height:100%;">
                                                <div class="meeting-schedule" style="margin-left: 3px !important;">
                                                    <div class="fw-600 text-white" style="margin-left: 2px;padding-top: 2px">{{meeting.month}}</div>
                                                    <div class="fw-600 text-white pb-1" style="margin-left: 7px;">{{meeting.day}}</div>
                                                </div>
                                                <div >
                                                    <div v-if="meeting.weekday == 'Monday'" class="text-left" style="margin-left: 2px !important;font-size: 12px !important;color: #00448b !important;">{{meeting.weekday}}</div>
                                                    <div v-if="meeting.weekday == 'Tuesday'" class="text-left" style="margin-left: 0px !important;font-size: 12px !important;color: #00448b !important;">{{meeting.weekday}}</div>
                                                    <div v-if="meeting.weekday == 'Wednesday'" class="text-left" style="margin-left: -10px !important;font-size: 12px !important;color: #00448b !important;">{{meeting.weekday}}</div>
                                                    <div v-if="meeting.weekday == 'Thursday'" class="text-left" style="margin-left: -2px !important;font-size: 12px !important;color: #00448b !important;">{{meeting.weekday}}</div>
                                                    <div v-if="meeting.weekday == 'Friday'" class="text-left" style="margin-left: 8px !important;font-size: 12px !important;color: #00448b !important;">{{meeting.weekday}}</div>
                                                    <div v-if="meeting.weekday == 'Saturday'" class="text-left" style="margin-left: -2px !important;font-size: 12px !important;color: #00448b !important;">{{meeting.weekday}}</div>
                                                    <div v-if="meeting.weekday == 'Sunday'" class="text-left" style="margin-left: 3px !important;font-size: 12px !important;color: #00448b !important;">{{meeting.weekday}}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-8 col-md-8 col-sm-8 mt-2">
                                            <div class="d-flex justify-content-between aline-items-center">
                                                <div style="padding-top:2px" class="text-truncate" :title="meeting.meeting_title"><span style="font-size: 12px;color: #00448b;">{{meeting.meeting_title}}</span></div>
                                                <!-- <div><i class="icon icon-dots-vertical fs-16" style="color:#000"></i></div> -->
                                            </div>
                                            <div><span style="font-size: 12px;color: #00448b;">{{convertDate(meeting.start_date)}}</span></div>
                                            <div class="pb-3 pt-1">
                                                <div class="d-flex align-items-center" v-if="meeting.invitees.length == 1">
                                                    <div class="symbol-group symbol-hover flex-nowrap">
                                                        <div class="symbol symbol-35px symbol-circle">
                                                            <el-tooltip class="item" effect="dark" :content="meeting.invitees[0].email" placement="top">
                                                                <div class="symbol symbol-35px symbol-circle">
                                                                    <img style="border-radius: 50%; border: 2px solid #ecf1f9;" :src="meeting.invitees[0].profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" width="30" height="30" />
                                                                </div>
                                                            </el-tooltip>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="d-flex align-items-center" v-if="meeting.invitees.length == 2">
                                                    <div class="symbol-group symbol-hover flex-nowrap">
                                                        <div class="symbol symbol-35px symbol-circle">
                                                            <el-tooltip class="item" effect="dark" :content="meeting.invitees[0].email" placement="top">
                                                                <div class="symbol symbol-35px symbol-circle">
                                                                    <img style="border-radius: 50%; border: 2px solid #ecf1f9;" :src="meeting.invitees[0].profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" width="30" height="30" />
                                                                </div>
                                                            </el-tooltip>
                                                        </div>
                                                        <div class="symbol symbol-35px symbol-circle">
                                                            <el-tooltip class="item" effect="dark" :content="meeting.invitees[1].email" placement="top">
                                                                <div class="symbol symbol-35px symbol-circle">
                                                                    <img style="border-radius: 50%; border: 2px solid #ecf1f9;" :src="meeting.invitees[1].profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" width="30" height="30" />
                                                                </div>
                                                            </el-tooltip>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="d-flex align-items-center" v-if="meeting.invitees.length == 3">
                                                    <div class="symbol-group symbol-hover flex-nowrap">
                                                        <div class="symbol symbol-35px symbol-circle">
                                                            <el-tooltip class="item" effect="dark" :content="meeting.invitees[0].email" placement="top">
                                                                <div class="symbol symbol-35px symbol-circle">
                                                                    <img style="border-radius: 50%; border: 2px solid #ecf1f9;" :src="meeting.invitees[0].profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" width="30" height="30" />
                                                                </div>
                                                            </el-tooltip>
                                                        </div>
                                                        <div class="symbol symbol-35px symbol-circle">
                                                            <el-tooltip class="item" effect="dark" :content="meeting.invitees[1].email" placement="top">
                                                                <div class="symbol symbol-35px symbol-circle">
                                                                    <img style="border-radius: 50%; border: 2px solid #ecf1f9;" :src="meeting.invitees[1].profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" width="30" height="30" />
                                                                </div>
                                                            </el-tooltip>
                                                        </div>
                                                        <div class="symbol symbol-35px symbol-circle">
                                                            <el-tooltip class="item" effect="dark" :content="meeting.invitees[2].email" placement="top">
                                                                <div class="symbol symbol-35px symbol-circle">
                                                                    <img style="border-radius: 50%; border: 2px solid #ecf1f9;" :src="meeting.invitees[2].profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" width="30" height="30" />
                                                                </div>
                                                            </el-tooltip>
                                                        </div>
                                                    </div>
                                                </div>
                                               <div class="d-flex align-items-center" v-if="meeting.invitees.length > 3">
                                                    <div class="symbol-group symbol-hover flex-nowrap">
                                                        <div class="symbol symbol-35px symbol-circle">
                                                            <el-tooltip class="item" effect="dark" :content="meeting.invitees[0].email" placement="top">
                                                                <div class="symbol symbol-35px symbol-circle">
                                                                    <img style="border-radius: 50%; border: 2px solid #ecf1f9;" :src="meeting.invitees[0].profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" width="30" height="30" />
                                                                </div>
                                                            </el-tooltip>
                                                        </div>
                                                        <div class="symbol symbol-35px symbol-circle">
                                                            <el-tooltip class="item" effect="dark" :content="meeting.invitees[1].email" placement="top">
                                                                <div class="symbol symbol-35px symbol-circle">
                                                                    <img style="border-radius: 50%; border: 2px solid #ecf1f9;" :src="meeting.invitees[1].profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" width="30" height="30" />
                                                                </div>
                                                            </el-tooltip>
                                                        </div>
                                                        <div class="symbol symbol-35px symbol-circle">
                                                            <el-tooltip class="item" effect="dark" :content="meeting.invitees[2].email" placement="top">
                                                                <div class="symbol symbol-35px symbol-circle">
                                                                    <img style="border-radius: 50%; border: 2px solid #ecf1f9;" :src="meeting.invitees[2].profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" width="30" height="30" />
                                                                </div>
                                                            </el-tooltip>
                                                        </div>
                                                        <a href="#" class="symbol symbol-35px symbol-circle"  data-bs-toggle="modal" data-bs-target="#kt_modal_view_users">
                                                            <el-popover
                                                                v-if="meeting.invitees.length > 3"
                                                                placement="bottom"
                                                                min-width="200"
                                                                trigger="hover">
                                                                <div v-for="(invite, index) in meeting.invitees" :key="index" style="display: inline-block !important;">
                                                                    <div v-if="index > 2" class="fw-500 email-chips p-1 mt-1 ml-1">
                                                                        <img style="border-radius: 50%; border: 2px solid #ecf1f9;" :src="invite.profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" width="25" height="25" />
                                                                        <span class="fw-500 fs-12 pt-1 pl-1">{{invite.email}}</span>
                                                                    </div>
                                                                </div>
                                                                <el-button slot="reference" class="pl-0 pr-0" style="padding: 0px !important;">
                                                                    <div class="symbol-label bg-dark fw-bold">
                                                                        +{{meeting.invitees.length - 3}}
                                                                    </div>
                                                                </el-button>
                                                            </el-popover>
                                                        </a>
                                                    </div>
                                               </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </fullscreen>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-sm-12 col-md-6 pl-4 pr-0 mt-4">
                        <fullscreen class="box-radius bg-white pb-5">
                            <div class="card-item bg-white text-auto pb-0" style="height: 220px;">
                                <div class="d-flex justify-content-between aline-items-center">
                                    <div class="fw-600 pr-5 fs-14">Associated Call Report</div>
                                    <div>
                                        <el-dropdown trigger="click" class="ml-4" :disabled="contact_details.status == 'archived'">
                                            <a href="javascript:;" :class="{'disabled-btn': contact_details.status == 'archived'}" class="btn btn-des-small ml-2" style="background:#008a63; height:30px !important;color: #fff;">+ Call Report</a>
                                            <el-dropdown-menu slot="dropdown">
                                                <el-dropdown-item @click.native="addCallReport('External Meeting')">External Meeting</el-dropdown-item>
                                                <el-dropdown-item @click.native="addCallReport('Internal Meeting')">Internal Meeting</el-dropdown-item>
                                                <el-dropdown-item @click.native="addCallReport('Review Meeting')">Review Meeting</el-dropdown-item>
                                                <el-dropdown-item @click.native="addCallReport('Sales Meeting')">Sales Meeting</el-dropdown-item>
                                            </el-dropdown-menu>
                                        </el-dropdown>
                                    </div>
                                </div>
                                <div v-if="call_reports.length == 0 && !load_call_reports" style="height:100% !important;">
                                    <h6 class="contentCenter text-center pt-5 h-100 fw-600 w-100">
                                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/callreport_schedule.svg" height="100">
                                        <h5 class="fw-500 text-capitalize fs-14 mt-4" style="color: #707070 !important;">No Call Report Added!</h5>
                                    </h6>
                                </div>
                                <div class="d-flex align-items-center justify-content-center" v-if="load_call_reports" style="height:175px;">
                                    <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                                </div>
                                <div v-else class="row pr-3 pt-2 pb-2" style="height:175px;overflow-y: scroll !important;">
                                    <div class="col-lg-4 col-sm-12 col-md-6 mt-2 pr-0" v-for="(callreport,callreport_index) in call_reports" :key="callreport_index">
                                        <div class="card-callreport" v-if="callreport_index < 9">
                                            <div class="d-flex justify-content-between aline-items-center">
                                                <div style="padding-top:2px" class="text-truncate" :title="callreport.call_report_number"><span style="font-size: 12px;color: #00448b !important;"><i class="logo-crm fs-12 pr-1" style="color:#00448b !important"></i>{{callreport.call_report_number}}</span></div>
                                                <div @click="viewLeadsCallReport(callreport.call_report_id)"><i class="icon icon-eye text-secondary pointer vertical-align-middle-icon fs-18"></i></div>
                                            </div>
                                            <div style="margin-top: -1px !important;"><span class="callreport-text fs-11" >{{callreport.call_report_type || "-"}}</span></div>
                                            <div class="d-flex justify-content-between aline-items-center">
                                                <div class="text-truncate" :title="callreport.created_by_name"><span class="callreport-text fs-10 text-truncate" :title="callreport.created_by_name"> {{callreport.created_by_name || "-"}}</span></div>
                                                <div><span class="callreport-text fs-10"> {{callreport.created_date || "-"}}</span></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </fullscreen>
                    </div>
                    <div class="col-lg-6 col-sm-12 col-md-6 pl-4 pr-6 mt-4">
                        <fullscreen class="box-radius bg-white pb-5">
                            <div class="card-item bg-white text-auto pb-0" style="height: 220px;">
                                <div class="d-flex justify-content-between aline-items-center mt-1">
                                    <div class="fw-600 pr-5 fs-14">Associated Expenses</div>
                                    <div>
                                        <button @click="addExpense"
                                            class="btn btn-des-small ml-2 text-white" :disabled="disableExpenseBtn || contact_details.status == 'archived'" style="background:#008a63; height:30px">+ Expenses
                                        </button>
                                    </div>
                                </div>
                                <div style="height:100% !important;" v-if="expense_details.length == 0 && !loadexpensereport">
                                    <h6 class="contentCenter text-center pt-5 h-100 fw-600 w-100">
                                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/callreport_schedule.svg" height="100">
                                        <h5 class="fw-500 text-capitalize fs-14 mt-4" style="color: #707070 !important;">No Expenses Added!</h5>
                                    </h6>
                                </div>
                                <div class="d-flex align-items-center justify-content-center" v-if="loadexpensereport" style="height:175px;">
                                    <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                                </div>
                                <div v-else class="row pr-3"  style="height:170px;overflow-y: scroll !important;">
                                    <div class="col-lg-4 col-sm-12 col-md-6 mt-2 pr-0" v-for="(expense,expense_index) in expense_details" :key="expense_index">
                                        <div class="card-expenses">
                                            <div class="d-flex justify-content-between aline-items-center">
                                                <div class="text-truncate" :title="expense.expense_name" style="padding-top:2px"><span style="font-size: 12px;color: #00448b;">{{expense.expense_name}}</span></div>
                                                <div @click="viewLeadsExpenseReport(expense._id)"><i class="icon icon-eye text-secondary pointer vertical-align-middle-icon fs-18"></i></div>
                                            </div>
                                            <div><span class="expenses-text">{{expense.expense_type.replaceAll('_', ' ') || "-" }}</span></div>
                                            <div class="d-flex justify-content-between aline-items-center">
                                                <div><span class="expenses-text"> {{expense.transaction_date}}</span></div>
                                                <div><span class="expenses-text"> {{currency}} {{expense.transaction_amount}}</span></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </fullscreen>
                    </div>
                </div>
            </div>
        </div>
        <!-- <add-meetings @hide-sm-modal="HideSmModel" v-if="sm_modal" :sm_id="sm_id" :sm_mode="sm_mode" modal_name="OpenSmModel" @hide-sm-modal-save="HideSmModelSave"></add-meetings> -->
        <select-call-reports from="contacts" @hide-selectcr-popup="HideSelectedCallReports" :call_report_ids="call_report_ids" :call_report_numbers="call_report_numbers" @hideSelectCallReportsOnSave="hideSelectCallReportsOnSave" v-if="show_cr_popup" modal_name="OpenAddCRModal"></select-call-reports>
        <view-leads-call-report :view_call_report_id="view_call_report_id" @selectedCallReports="selectedCallReports" v-if="show_view_call_reports" @hideViewCallReperts="hideViewCallReports" modal_name="view_leads_call_report"></view-leads-call-report>
        <create-meeting :view_mode="view_mode" @SaveSchedule="SaveSchedule" :reference_id="reference_id" :module_type="module_type" v-if="createscheduleMeeting" modal_name="createScheduleMeeting" @hideScheduleMeeting="hideScheduleMeetings"></create-meeting>
    </div>
</template>
<script>
    import { EventBus } from '../eventBus/nav-bar-event';
    import { HalfCircleSpinner } from "epic-spinners";
    import { SweetModal } from 'sweet-modal-vue';
    const AddMeetings = () => import('./AddMeetings')
    const ViewLeadsCallReport = () => import("../Leads/ViewLeadsCallReport")
    const SelectCallReports = () => import('../Customers/SelectCallReports')
    import Expense from "../mixins/expense";
    import globals from '../globals';
    import contacts from '../mixins/contacts'
    import deals from "../mixins/deals.js";
    import CreateMeeting from "../ScheduleMeeting/CreateScheduleMeeting";
    export default {
        data() {
            return {
                disableExpenseBtn: false,
                hideCallReportButton: false,
                show_cr_popup: false,
                hideAddMeetingButton: false,
                expandprofile: false,
                loadexpensereport:false,
                ajaxCallInProgress:false,
                load_meeting:false,
                load_call_reports:false,
                contact_interaction:false,
                contact_deals:false,
                show_view_call_reports: false,
                sm_modal: false,
                contact_type:'',
                expense_details:[],
                contact_details:[],
                contact_social_media:[],
                phone_number:[],
                interactions:[],
                interaction_count: 0,
                call_reports:[],
                schedule_meetings:[],
                call_report_ids: [],
                deal_details:[],
                sm_id: '',
                sm_mode: '',
                deal_pipelines:[],
                deal_id:[],
                view_call_report_id: '',
                createscheduleMeeting: false,
                module_type: "contacts",
                reference_id: '',
                load_contact_data: [],
                product_lead_data: [],
                empty_data: ''
            }
        },
        components: {
            SweetModal,
            HalfCircleSpinner,
            AddMeetings,
            SelectCallReports,
            ViewLeadsCallReport,
            CreateMeeting
        },
        mixins: [Expense,contacts,deals],
        methods: {
            SaveSchedule(){
                this.GetMeetingList()
            },
            goToViewDetails(){
                this.$router.push('/contacts/schedulemeeting/'+this.module_type+'/'+this.$route.params.id);
            },
            hideScheduleMeetings(){
                this.createscheduleMeeting = false;
            },
            createSchedule(){
                this.view_mode = 'create'
                this.module_type = 'contacts'
                this.createscheduleMeeting = true;
                setTimeout(() => {
                    this.$modal.show("createScheduleMeeting")
                }, 500);
            },
            HideSmModelSave(){
                this.sm_modal = false
                this.GetMeetingList()
            },
            addCallReport(category) {
                this.$store.commit("setCallReportCategory", category);
                localStorage.setItem("callReportCategory", category)
                let routeData = this.$router.resolve({name: 'callreport'});
                window.open(routeData.href+'callreport', '_blank');
            },
            viewLeadsCallReport(id){
                if(!this.userPermissions.call_reports.permitted_actions.view || !this.userPermissions.draft_call_reports.permitted_actions.view) {
                    this.$toasted.global.error("Permission Denied")
                } else {
                    this.view_call_report_id = null
                    if(id){
                        this.view_call_report_id = id
                    }
                    this.show_view_call_reports = true
                    setTimeout(() => {
                        this.$modal.show("view_leads_call_report")
                    }, 1000);
                }
            },
            hideViewCallReports(){
                this.show_view_call_reports = false
            },
            selectedCallReports(value){
                this.selected_call_reports = value
            },
            async getDealsDetails() {
                this.contact_deals = true;
                let params = {
                    skip: 0,
                    limit: 9,
                    search_key: '',
                    status: 'all',
                    filter_json: {
                        contact_id: [this.$route.params.id]
                    },
                }
                let response = await this.getDealsColumn(params);
                this.deal_details = response.response;
                this.contact_deals = false
            },
            async loadContactDetails(){
                let type = localStorage.getItem("contact_type")
                if(type == 'business'){
                    this.ajaxCallInProgress = true
                    let response = await this.getBusinessContactDetails(this.$route.params.id)
                    this.contact_details = response.response
                    this.phone_number = response.response.contact_phone_number[0]
                    this.contact_social_media =  response.response.contact_social_media
                    
                    // this.deal_pipelines = response.response.deal_pipelines
                    // this.deal_id = this.deal_pipelines.deal_pipeline_id
                    this.loadExpenseList();
                    this.ajaxCallInProgress = false
                }
                else{
                    this.ajaxCallInProgress = true
                    let response = await this.getPersonalContactDetails(this.$route.params.id)
                    this.contact_details = response.response
                    this.ajaxCallInProgress = false
                }
            },
            async GetMeetingList(){
                this.load_meeting = true
                let params = {
                    "product_name": "CRM",
                    "skip": 0,
                    "limit": 10,
                    "search_key": "",
                    "reference_id": this.$route.params.id,
                }
                let response = await this.getContactsMeetingList(params);
                this.schedule_meetings = response.response
                this.load_meeting = false
            },
            async loadInteractionsData() {
                this.contact_interaction = true
                let params = {
                    skip: 0,
                    limit: 10,
                    sort_value: 1,
                    sort_key: "id",
                    contact_id: this.$route.params.id
                }
                let response = await this.getContactsInteractionsData(params)
                this.interactions = response.response
                this.interaction_count = this.interactions.length
                this.interactions.forEach(x => {
                    x['created_time_format'] = new Date(x.created_time)
                    x['created_date'] = new Date(x.created_time)
                    x.created_date = new Date(x.created_time).toLocaleString('en-us', {
                        day: 'numeric',
                        month: 'short',
                        year: 'numeric'
                    })
                    var date = new Date(x.created_time_format);
                    var hours = date.getHours();
                    var minutes = date.getMinutes();
                    var newformat = hours >= 12 ? 'PM' : 'AM';
                    hours = hours % 12;
                    hours = hours ? hours : 12;
                    minutes = minutes < 10 ? '0' + minutes : minutes;
                    x.created_time_format = hours + ':' + minutes + ' ' + newformat;
                })
                this.contact_interaction = false
            },
            async GetCallReportList(){
                this.load_call_reports = true
                let params = {
                        "contact_id": this.$route.params.id,
                        "skip": 0,
                        "limit": 9,
                }
                let response = await this.getContactsCallReportList(params);
                this.call_reports = response.response
                this.call_report_numbers = this.call_reports.map(x => {return x.call_report_number})
                this.call_report_ids = this.call_reports.map(x => {return x.call_report_id})
                this.call_reports.forEach(x => {
                    x['created_time_format'] = new Date(x.created_time)
                    x['created_date'] = new Date(x.created_time)
                    x.created_date = new Date(x.created_time).toLocaleString('en-us', {
                        day: 'numeric',
                        month: 'numeric',
                        year: 'numeric'
                    })
                    var date = new Date(x.created_time_format);
                    var hours = date.getHours();
                    var minutes = date.getMinutes();
                    var newformat = hours >= 12 ? 'PM' : 'AM';
                    hours = hours % 12;
                    hours = hours ? hours : 12;
                    minutes = minutes < 10 ? '0' + minutes : minutes;
                    x.created_time_format = hours + ':' + minutes + ' ' + newformat;
                })
                this.load_call_reports = false
            },
            async loadExpenseList(){
                try {
                    this.loadexpensereport = true;
                    let params = {
                        "limit": 9,
                        "my_expense": true,
                        "search_key": "",
                        "skip": 0,
                        "filter_json" :{
                            "expense_created_for": [
                            this.$route.params.id,
                        ]
                        }
                    }
                    let response = await this.getexpenseList(params)
                    this.expense_details = response.response.expense_details;
                    this.loadexpensereport = false;
                }
                catch(err) {
                    if(err === 'UnAuthorized Request: Access Denied'){
                        this.disableExpenseBtn = true;
                    }
                    this.loadexpensereport = false;
                }
            },
            expandProfile(){
                this.expandprofile = !this.expandprofile;
            },
            viewLeadsExpenseReport(id){
                window.open(globals.EXPENSE_URL + '/expense/view/' + id, '_blank')
            },
            addExpense(){
                window.open(globals.EXPENSE_URL + `/expense/create?from=contacts&name=${this.contact_details.full_name}&id=${this.$route.params.id}`, '_blank')
            },
            HideSmModel(){
                this.sm_modal = false
                // this.GetMeetingList();
                // this.loadInteractionsData();
            },
            OpenSmModel(id){
                if(id == ''){
                    this.hideAddMeetingButton = true;
                }
                if(id != ''){
                    this.sm_id = id
                    this.sm_mode = 'edit'
                } else{
                    this.sm_id = ''
                    this.sm_mode = 'add'
                }
                this.sm_modal = true
                setTimeout(() => {
                    this.hideAddMeetingButton = false;
                    this.$modal.show('OpenSmModel')
                }, 1000)
            },
            HideSelectedCallReports(){
                this.show_cr_popup = false
                this.GetCallReportList();
                this.loadInteractionsData();
            },
            hideSelectCallReportsOnSave(){
                this.show_cr_popup = false
                this.GetCallReportList();
                this.loadInteractionsData();
            },
            OpenCRPopup(){
                this.hideCallReportButton = true;
                this.show_cr_popup = true
                setTimeout(() => {
                    this.hideCallReportButton = false;
                        this.$modal.show('OpenAddCRModal')
                }, 1000);
            },
            viewContact(id) {
                if(this.userPermissions.contacts_business.permitted_actions.view){
                    localStorage.setItem("contact_type","business")
                    this.$router.push('/contacts/view_contact/' + id);
                }
                else{
                    this.$toasted.global.error("Permission Denied")
                }
            },
            convertDate(str) {
                var date = str.slice(0,10).split("-"),
                mnth = date[1],
                day = date[2],
                year = date[0];
                var newDate = [mnth,day,year].join("-");
                return newDate
            },
            convertDateFormate(str) {
                var date = str.slice(0,11).split("-"),
                mnth = date[1],
                day = date[2],
                year = date[0];
                var newDate = [mnth,day,year].join("/");
                return newDate
            },
            async RedirectToCreateDeals(contact){
                this.load_contact_data = contact
                let params = {
                    contact_id: contact.id
                }
                let response = await this.getContactProducts(params)
                this.product_lead_data = response.response
                let data = {
                    deal_type: "contacts",
                    value: this.load_contact_data
                }
                localStorage.setItem("deal_type",JSON.stringify(data))
                if(this.product_lead_data.length > 0){
                    this.$router.push({
                            name:'CreateDeals',
                        params:{
                            id: contact.id
                        }
                    })
                } else {
                    this.$router.push({
                            name:'CreateContactCustomerDeals',
                        params:{
                            id: contact.id
                        }
                    })
                }
                // let data = {
                //     deal_type: "contacts",
                //     value: contact
                // }
                // localStorage.setItem("deal_type",JSON.stringify(data))
                // this.$router.push(`/deals/create/` + contact.id);   
            },
            refresh(){
                this.loadExpenseList();
                this.loadContactDetails();
                this.GetMeetingList();
                this.GetCallReportList();
                this.loadInteractionsData();
                this.getDealsDetails();
            },
            
        },
        mounted(){
            this.reference_id = this.$route.params.id 
            this.currency = this.loggedInUser.currency.symbol;
            this.contact_type = localStorage.getItem("contact_type")
            this.loadContactDetails();
            this.GetMeetingList();
            this.GetCallReportList();
            this.loadInteractionsData();
            this.getDealsDetails();
        },
        computed:{
            userPermissions(){
                return this.$store.getters.userPermissions;
            },
            loggedInUser() {
                return this.$store.getters.loggedInUser;
            },
        },

    }
</script>
<style scoped>
    .table-lead thead tr th:first-child{
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }
     .table-lead thead tr th:last-child{
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }
    .text-lead-ellipsis{
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 150px;
        width: 150px;
        white-space: nowrap;
    }
    .text-lead-ellipsis-company {
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 150px;
        width: 150px;
        white-space: nowrap;
    }
    .hot_lead {
        background: #fce5e5;
        color: #e82828;
        border: solid 1px #e82828;
        border-radius: 5px;
        padding: 6px 34px 6px 17px;
    }

    .warm_lead {
        background: #ffecd1;
        color: #ff9a06;
        border: solid 1px #ff9a06;
        border-radius: 5px;
        padding: 6px 17px 6px 17px;
    }

    .cold_lead {
        background: #c5daf8;
        color: #00448b;
        border: solid 1px #00448b;
        border-radius: 5px;
        padding: 6px 26px 6px 17px;
    }

    .hello {
        width: 100%;
        height: 500px;
    }

    .card-item {
        padding: 18px;
        border-radius: 6px;
    }

    .card-item-contact {
        padding: 18px;
        border-radius: 6px;
    }

    .ml-32px {
        margin-left: 32px;
    }

    #territoryDiv {
        width: 100%;
        height: 365px;
        background-image: linear-gradient(to bottom, #003e96, #001f4b);
    }

    #convertedLeadDiv {
        width: 100%;
        height: 405px;
    }

    #convertedDataDiv {
        width: 100%;
        height: 200px;
    }

    #campaignDiv {
        width: 100%;
        height: 340px;
    }

    #targetDiv {
        width: 100%;
        height: 340px;
    }

    #contactDiv {
        width: 100%;
        height: 400px;
    }

    .logo-image {
        width: 40px;
        height: 55px;
    }

    .contracts-logo {
        position: relative;
        bottom: 20px;
    }

    .pb-10px {
        padding-bottom: 10px;
    }

    .ongoing-survey-logo-image {
        width: 40px;
        height: 55px;
    }

    .meetings {
        border: 1px solid #005dae;
        border-radius: 4px;
        padding-top: 8px;
    }

    #targetachievedDiv {
        width: 100%;
        height: 300px;
    }

    #trendsDiv {
        width: 100%;
        height: 345px;
    }

    #salesValue {
        width: 100%;
        height: 340px;
    }

    .text-rotate {
        transform: rotate(-90deg);
        position: relative;
        right: 316px;
        top: 150px;
    }
    table thead th,
    table tbody td {
        padding: 10px;
    }

    #days {
        cursor: pointer;
    }

    .expand-img {
        width: 18px;
        margin-bottom: 2px;
    }

    .today-meetings {
        min-height: 377px;
        max-height: 377px;
        overflow: auto;
    }

    .icon-images {
        width: 24px;
        padding-right: 10px;
    }

    .copy-icon-images {
        width: 30px;
    }

    .mediaDiv {
        border: 1px solid #6491cb;
        border-radius: 2px;
        height: 200px
    }

    .icon_div {
        background-color: #ffe1dd;
        border: 1px solid #ccc;
        color: #ef1747;
    }

    .icon_div_green {
        background-color: #cce8e0;
        border: 1px solid #ccc;
        color: #008a63;
    }

    .contactMedia {
        width: 100%;
        height: 280px !important;
    }

    .new-blue {
        color: #00448b !important;
    }

    .slant-tabs {
        position: relative;
        height: 40px;
        min-width: 100px !important;
        text-align: center;
        line-height: 44px;
        color: #7b7f97;
        text-transform: capitalize;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
    }

    .new-blue {
        background-color: #e5eaed
    }

    .div-space {
        padding-right: 8px !important;
        padding-left: 5px !important;
    }

    .text-data {
        text-transform: capitalize !important;
    }

    .dropdown-button {
        background-color: #fff !important;
        height: 30px;
        border-radius: 8px;
        font-size: 14px;
        font-weight: 500;
        padding: 0 1.5rem;
    }

    .dropdown-button:focus {
        border: 1px solid #0F5DAF !important;
    }

    .dropdown-toggle::after {
        font-size: 20px;
    }

    .dropdown-button span {
        color: #000;
        font-weight: 400;
    }

    .dropdown-submenu {
        position: relative;
        padding: 0;
    }

    .dropdown-item-toggle {
        margin-right: 5px;
    }

    .dropdown-item-toggle::after {
        position: absolute;
        right: 7px;
        content: '▸';
        color: #aaa;
        margin-left: 0.5rem;
    }

    .dropdown-menu {
        top: 4px !important;
        left: 10px !important;
        margin-top: -1px;
        border-radius: 8px;
    }

    .sub-dropdown {
        left: -80% !important;
        width: 78%;
        margin: 0px;
        padding: 0px;
    }

    .dropdown-label {
        font-size: 16px;
        font-weight: 400;
        margin-right: 8px;
    }

    .select-css {
        border-radius: 6px;
        border: 0.6px solid #d7dae2 !important;
    }

    .el-select.drop-data .el-input__icon {
        line-height: 0px !important
    }

    .box-radius {
        border-radius: 7px !important;
    }

    .trendsDiv-expand {
        width: 100%;
        height: 500px !important;
        margin: auto;
        vertical-align: middle;
        line-height: 0 !important;
    }

    .contactDiv-expand {
        width: 100%;
        height: 600px !important;
        margin: auto;
        vertical-align: middle;
    }

    #historyDiv {
        height: 90px !important;
    }

    .trendsDiv-expand,
    .territoryDiv-expand,
    .convertedLeadDiv-expand,
    .historyDiv-expand {
        width: 100%;
        height: 500px !important;
        margin: auto;
        vertical-align: middle;
        line-height: 90
    }

    #salesValue {
        width: 100%;
        height: 400px;
    }

    .table-lead {
        border-collapse: collapse;
        width: 100%;
        height: 854px;
    }

    table thead th {
        padding: 10px;
        letter-spacing: 0.86px;
    }

    table.table-lead tbody tr {
        border-bottom: solid 1px #f2f3f5;
    }

    table.table-lead tbody td {
        padding: 16px 10px !important;
        font-size: 14px;
        color: #206ad3;
    }

    .badgelead {
        display: inline-block;
        padding: 6px 6px;
        font-size: 13px;
        font-weight: normal;
        line-height: 1;
        text-align: center;
        white-space: nowrap;
        vertical-align: baseline;
        -webkit-border-radius: 4px;
        border-radius: 4px;
        width: 100px;
    }

    .badgelead-hotlead {
        background: #fce5e5;
        border: 0.5px solid #e82828;
        color: #e82828;
    }

    .badgelead-coldlead {
        background: #c5daf8;
        border: 0.5px solid #206ad3;
        color: #206ad3;
    }

    .badgelead-warmlead {
        background: #ffecd1;
        border: 0.5px solid #ff9a06;
        color: #ff9a06;
    }
    .leadFullscreen.fullscreen {
        overflow-y:scroll !important;
    }
    .leadFullscreen.fullscreen .text-lead-ellipsis{
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 300px;
        width: 300px;
        white-space: nowrap;
    }

    .leadFullscreen.fullscreen .text-lead-ellipsis-company {
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 200px;
        width: 200px;
        white-space: nowrap;
    }
    .list-lead-img{
        width: 100% !important;
        height: 50% !important;
        margin-top: -300px !important;
    }
    .card-expenses{
        background-color: #cce3fc;
        border: 1px solid #206ad3;
        border-radius: 6px;
        height: 70px;
        padding: 5px;
    }
    .expenses-text{
        font-size: 10px;
        color: #89898d;
    }
    .card-callreport{
        background-color: #fff;
        border: 1px solid #206ad3;
        border-radius: 6px;
        height: 70px;
        padding: 5px;
    }
    .callreport-text{
        font-size: 10px;
        color: #89898d;
    }
    .product-cards {
        border: 1px solid #00448b;
        padding: 5px !important;
        border-radius: 6px;
    }
    .div-spacing {
        padding-left: 0px !important;
        padding-right: 0px !important;
        color: #3f3f3f !important;
    }
    .product-header{
        font-size: 12px;
        color: #206ad3;
        font-weight: 500
    }
    .upcoming-card {
        height: 100%;
        margin: 10px 0 0 0;
        padding: 0px;
        border-radius: 8px;
        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
        background-color: #fff;
    }
    .btn-new-blue {
        border: 2px solid #005dae;
        color:#fff;
        line-height: 30px;
        border-radius: 5px;
        background-color: #005dae;
        text-transform: capitalize;
    }
    .step-title{
        position: absolute;
    }
    .call-report-div{
        margin-left: 20px;
        border: 1px solid #0D75E8;
        border-radius: 8px;
        padding: 2px 12px;
        box-shadow: 1px 1px 2px darkgrey;
    }
    .pearls {
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        margin: 0 0 0px;
        justify-content: center;
    }
    .pearl {
        position: relative;
        padding: 0;
        margin: 0;
        text-align: center;
    }
    .pearle {
        position: relative;
        padding: 0;
        margin: 0;
        text-align: center;
    }
    .pearles {
        position: relative;
        padding: 0;
        margin: 0;
        text-align: center;
    }
    .col-2 {
        -ms-flex: 0 0 16.666666666%;
        flex: 0 0 16.666666666%;
        max-width: 100%;
        width: 100%;
        min-height: 2px;
    }
    .five-stage {
        -ms-flex: 0 0 20%;
        flex: 0 0 20%;
        max-width: 100%;
        width: 100%;
        min-height: 2px;
    }
    .col-3 {
        -ms-flex: 0 0 25%;
        flex: 0 0 25%;
        max-width: 100%;
        width: 100%;
        min-height: 2px;
    }
    .col-4 {
        -ms-flex: 0 0 33.3333333333%;
        flex: 0 0 33.3333333333%;
        max-width: 100%;
        width: 100%;
        min-height: 2px;
    }
    .col-6 {
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        max-width: 100%;
        width: 100%;
        min-height: 2px;
    }
    .col-12{
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
        width: 100%;
        min-height: 2px;
    }
    .pearl:before, .pending:before, .active:before, .hold:before, .complete:before, .skip:before {
        left: 0;
    }
    .pearl:after, .pearl:before {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #eee;
    }
    .pearle:after{
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #eee;
    }
    .pearles:before {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        margin-left: -36%;
        background-color: #eee;
    }
    .pearl-icon {
        font-size: 18px;
    }
    .pearl-icon, .pearl-number {
        position: relative;
        z-index: 1;
        display: inline-block;
        width: 30px;
        height: 30px;
        line-height: 32px;
        color: #fff;
        text-align: center;
        background: #bdbdbd;
        border-radius: 50%;
        border: 5px solid #fff;
        outline: 5px solid #bdbdbd;
    }
    .icon {
        display: inline-block;
        font-style: normal;
        font-weight: 400;
        text-rendering: auto;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        -webkit-transform: translate(0,0);
        transform: translate(0,0);
        line-height: 1;
    }
    .pearl-title {
        margin-top: 0.5em;
        display: block;
        font-size: 14px;
        color: #616161;
        margin-bottom: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .btn-new-blue {
        border: 2px solid #005dae;
        color:#fff;
        line-height: 30px;
        border-radius: 5px;
        background-color: #005dae;
        text-transform: capitalize;
    }
    .pending {
        position: relative;
        padding: 0;
        margin: 0;
        text-align: center !important;
    }
    .active {
        position: relative;
        padding: 0;
        margin: 0;
        text-align: center !important;
    }
    .hold {
        position: relative;
        padding: 0;
        margin: 0;
        text-align: center !important;
    }
    .complete {
        position: relative;
        padding: 0;
        margin: 0;
        text-align: center !important;
    }
    .skip {
        position: relative;
        padding: 0;
        margin: 0;
        text-align: center !important;
    }
    .pending .pearl-icon{
        color: #c4c4c4;
        background-color: #c4c4c4;
        border-color: #fff;
        outline: 5px solid #c4c4c4;
    }
    .active .pearl-icon{
        color: #FFBF02;
        background-color: #FFBF02;
        border-color: #fff;
        outline: 5px solid #FFBF02;
    }
    .hold .pearl-icon{
        color: #E25251;
        background-color: #E25251;
        border-color: #fff;
        outline: 5px solid #E25251;
    }
    .complete .pearl-icon{
        color: #1D8A5F;
        background-color: #1D8A5F;
        border-color: #fff;
        outline: 5px solid #1D8A5F;
    }
    .skip .pearl-icon{
        color: #676767;
        background-color: #676767;
        border-color: #fff;
        outline: 5px solid #676767;
    }

    .pending:before {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #c4c4c4;
    }
    .pending:after {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #c4c4c4;
    }
    .active:before {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #FFBF02;
    }
    .active:after {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #FFBF02;
    }
    .hold:before {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #E25251;
    }
    .hold:after {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #E25251;
    }

    .complete:before {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #1D8A5F;
    }
    .complete:after{
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #1D8A5F;
    }
    .skip:before {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #676767;
    }
    .skip:after {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #676767;
    }
    .pending-b:before {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #c4c4c4;
        display: none;
    }
    .pending-a:after {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #c4c4c4;
        display: none;
    }
    .active-b:before {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #FFBF02;
        display: none;
    }
    .active-a:after {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #FFBF02;
        display: none;
    }
    .hold-b:before {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #E25251;
        display: none;
    }
    .hold-a:after {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #E25251;
        display: none;
    }

    .complete-b:before {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #1D8A5F;
        display: none;
    }
    .complete-a:after{
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #1D8A5F;
        display: none;
    }
    .skip-b:before {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #676767;
        display: none;
    }
    .skip-a:after {
        position: absolute;
        top: 14px;
        z-index: 0;
        width: 50%;
        height: 4px;
        content: "";
        background-color: #676767;
        display: none;
    }
    .pending-title {
        margin-top: 0.5em;
        display: block;
        font-size: 14px;
        color: #c4c4c4;
        margin-bottom: 0;
        line-break: anywhere;
    }
    .active-title {
        margin-top: 0.5em;
        display: block;
        font-size: 14px;
        color: #FFBF02;
        margin-bottom: 0;
        line-break: anywhere;
    }
    .hold-title {
        margin-top: 0.5em;
        display: block;
        font-size: 14px;
        color: #E25251;
        margin-bottom: 0;
        line-break: anywhere;
    }
    .complete-title {
        margin-top: 0.5em;
        display: block;
        font-size: 14px;
        color: #1D8A5F;
        margin-bottom: 0;
        line-break: anywhere;
    }
    .skip-title {
        margin-top: 0.5em;
        display: block;
        font-size: 14px;
        color: #676767;
        margin-bottom: 0;
        line-break: anywhere;
    }
   @media only screen and (min-width: 768px) and (max-width: 1024px) {
    .col-2 {
        -ms-flex: 0 0 16.666666666%;
        flex: 0 0 16.666666666%;
        max-width: 100%;
        width: 70px;
        min-height: 2px;
    }
    .five-stage {
        -ms-flex: 0 0 20%;
        flex: 0 0 20%;
        max-width: 100%;
        width: 85px;
        min-height: 2px;
    }
    .col-3 {
        -ms-flex: 0 0 25%;
        flex: 0 0 25%;
        max-width: 100%;
        width: 100px;
        min-height: 2px;
    }
    .col-4 {
        -ms-flex: 0 0 33.3333333333%;
        flex: 0 0 33.3333333333%;
        max-width: 100%;
        width: 140px;
        min-height: 2px;
    }
    .col-6 {
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        max-width: 100%;
        width: 200px;
        min-height: 2px;
    }
    .col-12{
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
        width: 100%;
        min-height: 2px;
    }
}
@media only screen and (min-width: 1025px) and (max-width: 1280px) {
    .col-2 {
        -ms-flex: 0 0 16.666666666%;
        flex: 0 0 16.666666666%;
        max-width: 100%;
        width: 95px;
        min-height: 2px;
    }
    .five-stage {
        -ms-flex: 0 0 20%;
        flex: 0 0 20%;
        max-width: 100%;
        width: 110px;
        min-height: 2px;
    }
    .col-3 {
        -ms-flex: 0 0 25%;
        flex: 0 0 25%;
        max-width: 100%;
        width: 140px;
        min-height: 2px;
    }
    .col-4 {
        -ms-flex: 0 0 33.3333333333%;
        flex: 0 0 33.3333333333%;
        max-width: 100%;
        width: 190px;
        min-height: 2px;
    }
    .col-6 {
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        max-width: 100%;
        width: 280px;
        min-height: 2px;
    }
    .col-12{
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
        width: 100%;
        min-height: 2px;
    }
}
@media only screen and (min-width: 1281px) and (max-width: 1440px) {
    .col-2 {
        -ms-flex: 0 0 16.666666666%;
        flex: 0 0 16.666666666%;
        max-width: 100%;
        width: 115px;
        min-height: 2px;
    }
    .five-stage {
        -ms-flex: 0 0 20%;
        flex: 0 0 20%;
        max-width: 100%;
        width: 130px;
        min-height: 2px;
    }
    .col-3 {
        -ms-flex: 0 0 25%;
        flex: 0 0 25%;
        max-width: 100%;
        width: 175px;
        min-height: 2px;
    }
    .col-4 {
        -ms-flex: 0 0 33.3333333333%;
        flex: 0 0 33.3333333333%;
        max-width: 100%;
        width: 230px;
        min-height: 2px;
    }
    .col-6 {
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        max-width: 100%;
        width: 340px;
        min-height: 2px;
    }
    .col-12{
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
        width: 100%;
        min-height: 2px;
    }
}
@media only screen and (min-width: 1441px) and (max-width: 1699px) {
    .col-2 {
        -ms-flex: 0 0 16.666666666%;
        flex: 0 0 16.666666666%;
        max-width: 100%;
        width: 130px;
        min-height: 2px;
    }
    .five-stage {
        -ms-flex: 0 0 20%;
        flex: 0 0 20%;
        max-width: 100%;
        width: 145px;
        min-height: 2px;
    }
    .col-3 {
        -ms-flex: 0 0 25%;
        flex: 0 0 25%;
        max-width: 100%;
        width: 195px;
        min-height: 2px;
    }
    .col-4 {
        -ms-flex: 0 0 33.3333333333%;
        flex: 0 0 33.3333333333%;
        max-width: 100%;
        width: 260px;
        min-height: 2px;
    }
    .col-6 {
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        max-width: 100%;
        width: 390px;
        min-height: 2px;
    }
    .col-12{
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
        width: 100%;
        min-height: 2px;
    }
}
@media only screen and (min-width: 1700px) and (max-width: 1920px) {
    .col-2 {
        -ms-flex: 0 0 16.666666666%;
        flex: 0 0 16.666666666%;
        max-width: 100%;
        width: 155px;
        min-height: 2px;
    }
    .five-stage {
        -ms-flex: 0 0 20%;
        flex: 0 0 20%;
        max-width: 100%;
        width: 170px;
        min-height: 2px;
    }
    .col-3 {
        -ms-flex: 0 0 25%;
        flex: 0 0 25%;
        max-width: 100%;
        width: 233px;
        min-height: 2px;
    }
    .col-4 {
        -ms-flex: 0 0 33.3333333333%;
        flex: 0 0 33.3333333333%;
        max-width: 100%;
        width: 310px;
        min-height: 2px;
    }
    .col-6 {
        -ms-flex: 0 0 50%;
        flex: 0 0 50%;
        max-width: 100%;
        width: 465px;
        min-height: 2px;
    }
    .col-12{
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
        width: 100%;
        min-height: 2px;
    }
}
    .circle-button {
        height: 23px;
        width: 23px;
        background-color: #00448b;
        border-radius: 50%;
        display: inline-block;
        margin-top: -4px;
        padding-right: 24px !important;
    }
    .timeline {
        border-left: 2px solid #00448b;
        border-bottom-right-radius: 4px;
        border-top-right-radius: 4px;
        background: rgba(255, 255, 255, 0.03);
        color: rgba(255, 255, 255, 0.8);
        padding: 0px 0px 8px 0px !important;
        position: relative;
        line-height: 1.4em;
        overflow-x: initial;
        font-size: 14px;
        list-style: none;
        text-align: left;
        font-weight: 100;
        margin-left: 6px !important;
        max-width: 100% !important;
    }

    .timeline h3 {
        color: #303031 !important;
    }

    .timeline p {
        color: #303031 !important;
    }

    .timeline h1 {
        font-weight: 100;
        font-size: 1.4em;
    }

    .timeline h2,
    .timeline h3 {
        font-weight: 400;
        font-size: 16px;
    }

    .timeline .event {
        border-bottom: 1px dashed rgba(255, 255, 255, 0.1);
        padding-bottom: 0px;
        margin-bottom: 0px;
        position: relative;
    }

    .timeline .event:last-of-type {
        padding-bottom: 0;
        margin-bottom: 0;
        border: none;
    }

    .timeline .event:before,
    .timeline .event:after {
        position: absolute;
        display: block;
        top: 0;
    }

    .timeline .event:before {
        left: -217.5px;
        color: #303031 !important;
        content: attr(data-date);
        text-align: right;
        font-weight: 500;
        font-size: 0.9em;
        min-width: 120px;
    }

    .timeline .event:after {
        left: -13.6px;
        background: #ffffff;
        border-radius: 50%;
        height: 25px;
        width: 25px;
        content: "";
        top: 0px;
        border: 8px solid #00448b;
        box-shadow: 0 0 5px 0 #71acff;
    }

    .timeline .event-completed:after {
        font-family: 'fuse-iconfont';
        left: -13.6px;
        background: #34ac3d !important;
        border-radius: 50%;
        height: 25px;
        width: 25px;
        content: "\ea7b";
        color: #fff;
        padding-top: 5px;
        font-size: 28px;
        top: 5px;
        border: 6px solid #34ac3d !important;
        box-shadow: 0 0 5px 0 #34ac3d !important;
    }

    .timeline .event .today-span {
        left: -187.5px;
        color: #303031 !important;
        text-align: right;
        font-weight: 500;
        font-size: 0.9em;
        min-width: 120px;
        position: absolute;
        display: block;
        top: 0;
    }

    .timeline .event .date-span {
        left: -187.5px;
        color: #303031 !important;
        text-align: right;
        font-weight: 500;
        font-size: 0.9em;
        min-width: 120px;
        position: absolute;
        display: block;
        top: 19px;
    }
    .meeting-schedule{
        background-image: url("https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/schedule.svg");
        background-repeat: no-repeat;
        background-size: contain;
        padding-left: 10px;
        padding-top: 4px;
        width: 45px !important;
        margin-left: -6px !important;
    }
    .social-media-icons{
      width: 1.5em;
      height: 1.5em;
    }
    .height{
        height:523px;
    }
    .height-one{
        height:385px;
    }
    .recent-activity{
        height: 350px;
    }
    .recent-height{
        height: 480px;
    }
    .padding{
        margin-left: -10px;
    }
    .padding-sf{
        margin-left: 3px;
    }
    .text-dark-red {
        color: #f80c17 !important;
    }

    .text-medium-status {
        color: #ff9a35 !important;
    }

    .text-low-status {
        color: #005dae !important;
    }
    .email-chips{
        display: inline-flex;
        background: #dfe8f4;
        margin-bottom: 8px;
        border-radius: 25px;
        cursor: pointer;
        color: #4e5764;
    }
    .symbol-group {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-left: 10px;
    }
    .flex-nowrap {
        flex-wrap: nowrap!important;
    }
    .symbol-group.symbol-hover .symbol {
        cursor: pointer;
    }
    .symbol-group .symbol {
        position: relative;
        z-index: 0;
        margin-left: -6px;
        transition: all .3s ease;
    }
    .symbol-group .symbol:hover {z-index: 1;}
    .symbol.symbol-circle, .symbol.symbol-circle .symbol-label, .symbol.symbol-circle>img {
        border-radius: 50%;
    }
    .symbol {
        display: inline-block;
        flex-shrink: 0;
        position: relative;
        border-radius: 0.475rem;
        text-decoration: none !important;
    }
    .symbol.symbol-35px .symbol-label {
        
        width: 28px;
        height: 28px;
        font-size: 10px;
        font-weight: 600 !important;
    }
    .symbol-group .symbol-label {
        position: relative;
        color: #fff !important;
        text-decoration: none !important;
    }
    .symbol .symbol-label {
        display: flex;
        align-items: center;
        justify-content: center;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
        border-radius: 0.475rem;
    }
    .bg-dark {
        background-color: #00448b !important;
    }
    .disabled-btn{
        background: rgba(0,0,0,0.12) !important;
        color: rgba(0,0,0,0.26) !important;
    }
    .btn-blue{
        background-color: #00448b;
        color: #fff;
        border-radius: 4px;
        font-size: 12px !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/Contacts/IndividualContactDashboard.vue